import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '@mui/material';
import { useGetEndUserSpaceQuery } from '../../app/smorgAppSyncGraphQLApiCustomHooks';

const NarrowEndUserMoreButton = ({ onClick, isLoading }) => {
  const { data: currentSpace } = useGetEndUserSpaceQuery();
  const whiteLabelElements = currentSpace?.whiteLabelElements;

  const backgroundColor =
    whiteLabelElements?.cardBackgroundColor ||
    whiteLabelElements?.primaryMainColor;

  return (
    <div
      style={{
        display: 'flex',
        width: 166,
        height: 260,
        minWidth: 166,

        margin: '6px',
      }}>
      <Button
        onClick={onClick}
        variant="contained"
        size="medium"
        fullWidth
        disableElevation
        disabled={isLoading}
        style={{
          borderRadius: '8px',
          padding: '12px',
          margin: 'auto',
          backgroundColor,
        }}>
        {isLoading ? 'Loading...' : 'More...'}
      </Button>
    </div>
  );
};

NarrowEndUserMoreButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  isLoading: PropTypes.bool.isRequired,
};

export default NarrowEndUserMoreButton;
